import { useTheme } from '@mui/material'

// Backend serializes event types as Norwegian display names ("Fellesfeil", "Planlagt",
// "Generell") via EnumToString.EventTypeDictionary; some callers also reference the short
// 2-letter form ("FF" / "PA" / "GE"). Both shapes resolve to the same theme token.
export function useEventTypeColor(): (type: string | undefined | null) => string {
  const theme = useTheme()
  return (type) => {
    switch (type) {
      case 'FF':
      case 'Fellesfeil':
        return theme.palette.eventType.fellesfeil
      case 'PA':
      case 'Planlagt':
        return theme.palette.eventType.planlagt
      case 'GE':
      case 'Generell':
        return theme.palette.eventType.generell
      default:
        return theme.palette.grey[400]
    }
  }
}
